"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GalleryImageItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = require("@site/pattern-library-core/image");
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
const GalleryItem = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GalleryItem",
  class: "pl-g1n2j0po"
});
const ItemContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ItemContent",
  class: "pl-i1fyfnq1"
});
const ItemImage = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "ItemImage",
  class: "pl-i55wixu"
});
const ItemImageWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ItemImageWrapper",
  class: "pl-i7qbdps"
});

/**
 * GalleryImageItem component.
 * @param {Object} props React Props
 * @param {string} props.id The Gallery Item's id
 * @param {string} props._name The tracking name for the component
 * @param {string} props.title The item's title
 * @param {string} props.subtitle The item's subtitle
 * @param {object} props.image The item's image object
 * @param {Array} [buttons] A List of the item's call to actions
 * @param {string} props.windowOptions The window options for following a link
 * @returns {React.ReactElement} GalleryImageItem component
 * @public
 */
function GalleryImageItem({
  id,
  _name,
  url,
  title,
  subtitle,
  image,
  buttons,
  windowOptions,
  headlineLockup = null
}) {
  return /*#__PURE__*/_react.default.createElement(GalleryItem, {
    "data-cy": "gallery-item",
    padding: "none",
    id: `id-${id}`
  }, /*#__PURE__*/_react.default.createElement(ItemContent, null, /*#__PURE__*/_react.default.createElement(ItemImageWrapper, {
    className: url ? 'hover' : ''
  }, url ? /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: url,
    target: windowOptions,
    "aria-label": buttons && buttons[0]?.ariaLabel || 'gallery-item-link'
  }, _name && {
    ..._patternLibraryUtils.tracking.create(_name, false, true)
  }), image && /*#__PURE__*/_react.default.createElement(ItemImage, {
    alt: image.altText,
    src: image.url,
    "data-cy": "gallery-item-image"
  })) : /*#__PURE__*/_react.default.createElement("div", {
    "aria-label": "gallery-item-no-link",
    "data-cy": "gallery-item-image-wrapper"
  }, image && /*#__PURE__*/_react.default.createElement(ItemImage, {
    alt: image.altText,
    src: image.url,
    "data-cy": "gallery-item-image"
  }))), /*#__PURE__*/_react.default.isValidElement(headlineLockup) ? (
  /*#__PURE__*/
  // TODO: CMS-30265: Remove this logic entirely. Should only render item as a React Node.
  _react.default.cloneElement(headlineLockup, {
    ...headlineLockup.props,
    headlineSize: 'h5',
    headlineTag: 'h3',
    headlineLineLength: 2,
    actionsLayout: 'button-set',
    textAlign: 'start',
    ctaFlexDirection: 'row'
  })) : /*#__PURE__*/_react.default.createElement(_index.default, {
    headlineSize: "h5",
    headlineTag: "h3",
    headlineLineLength: 2,
    heading: title,
    description: subtitle,
    actionsLayout: "button-set",
    ctas: buttons,
    textAlign: "start",
    ctaFlexDirection: "row"
  })));
}
GalleryImageItem.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  url: _propTypes.default.string,
  title: _propTypes.default.string,
  subtitle: _propTypes.default.string,
  image: _propTypes.default.shape(_image.imgPropShape),
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape(_merchButton.NSMerchButton.propTypes)),
  windowOptions: _propTypes.default.string,
  headlineLockup: _propTypes.default.node
};